var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PieChart',{ref:"distributionPieChart",attrs:{"chart-data":_vm.chartData,"options":_vm.pieChartOptions,"width":_vm.Width,"height":_vm.Height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }